var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvenSkinTexture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.852,
    height: 82.064,
    viewBox: "0 0 74.852 82.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18926.063 19287.886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M947.483,15.725l1.449-1.85a.452.452,0,0,0-.355-.73h-2.9a.452.452,0,0,0-.355.73l1.449,1.85a.45.45,0,0,0,.71,0",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.483,15.725l1.449-1.85a.452.452,0,0,0-.355-.73h-2.9a.452.452,0,0,0-.355.73l1.449,1.85A.45.45,0,0,0,947.483,15.725Z",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.943,
    transform: "translate(-18897.873 -19277.707)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.485,23.151,955.934,25a.452.452,0,0,1-.355.73h-2.9a.452.452,0,0,1-.355-.73l1.449-1.85a.45.45,0,0,1,.71,0",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.485,23.151,955.934,25a.452.452,0,0,1-.355.73h-2.9a.452.452,0,0,1-.355-.73l1.449-1.85A.45.45,0,0,1,954.485,23.151Z",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y2: 3.943,
    transform: "translate(-18890.871 -19264.01)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.321,51.052c-.1.446-.439.544-1.743,1.45a4.777,4.777,0,0,1-4.9,0c-1.3-.906-1.639-1-1.743-1.45",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.9,37.4a3.322,3.322,0,0,1,4.089.022,7.966,7.966,0,0,0,3.406,1.742,8.338,8.338,0,0,0,2.682.141,19.675,19.675,0,0,0,3.528-.847c.833-.234,1.532-.434,2.041-.58",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.182,40.653a3.19,3.19,0,0,1,2.507-1.694",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.178,37.4a3.322,3.322,0,0,0-4.089.022,7.966,7.966,0,0,1-3.406,1.742A8.333,8.333,0,0,1,966,39.3a19.654,19.654,0,0,1-3.529-.847c-.833-.234-1.532-.434-2.041-.58",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.386,38.959a3.19,3.19,0,0,1,2.507,1.694",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.879,19.283c.2,6.293-.736,30.857.679,36.191,2.482,9.324,13.7,18.48,20.754,23.456a9.984,9.984,0,0,0,11.674,0c2.172-1.53,4.737-3.458,7.319-5.663",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.147,33.683c-.2,6.293.736,16.457-.679,21.791-2.482,9.324-13.7,18.48-20.754,23.456a9.987,9.987,0,0,1-11.674,0c-2.172-1.53-4.737-3.458-7.319-5.663",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.55,29.741a8.669,8.669,0,0,0-5.187-2.767,28.444,28.444,0,0,0-8.127,0",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.617,29.7a8.669,8.669,0,0,1,5.187-2.767,28.452,28.452,0,0,1,8.128,0",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954,5.618A165.334,165.334,0,0,1,967.613,16.48c10.5,9.683,18.069,23.972,24.264,41.646",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 12.251,
    x2: 23.059,
    transform: "translate(-18918.121 -19281.293)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.228,
    x2: 8.049,
    transform: "translate(-18891.002 -19285.936)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.073,
    x2: 7.662,
    transform: "translate(-18878.346 -19275.781)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 1.283,
    x2: 3.201,
    transform: "translate(-18863.584 -19255.77)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 1.812,
    x2: 4.518,
    transform: "translate(-18867.531 -19262.564)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.718,
    x2: 1.792,
    transform: "translate(-18859.766 -19249.236)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.877,
    x2: 2.188,
    transform: "translate(-18857.738 -19242.734)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.505,
    x2: 1.26,
    transform: "translate(-18855.027 -19236.463)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 2.255,
    x2: 5.624,
    transform: "translate(-18872.063 -19269.58)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.265,
    x2: 8.143,
    transform: "translate(-18883.186 -19281.619)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.311,65.3a1.374,1.374,0,0,1-.331-.064c.029-.04.043-.062.043-.062l-.2,0c-1.614-.708-2.965-4.189-3.942-4.565a7.888,7.888,0,0,0-2.32.392c-.392.114-1.8-.621-2.14-.441-.663.347-1.144,1.487-1.618,2.565a5.858,5.858,0,0,1-1.824,2.217h-.016l.006.007c-.1.071.15.174.15.174.827,1.014,2.182,3.284,6,3.166,3.239-.1,5.35-2.754,5.806-3.384Z",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.759,25.125c-1.136,3.689-6.322,7.343-6.322,14.176s1.547,8.7,5.074,8.7",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986,43.435c-.572,3.063-1.9,3.065-3.278,3.065a1.5,1.5,0,0,0,0,3c2.414,0,3.976-.8,4.97-2.221q-.829-1.958-1.692-3.844",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.679,30.983V15.563l1.657-1.078,20.817-11.06",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.328,18.486a6.079,6.079,0,0,0-4.218,1.387,7.876,7.876,0,0,1-10.18-.426,6.313,6.313,0,0,0-8.307-.347,7.559,7.559,0,0,1-5.168,1.656l-.019,0c.062.169.129.334.2.5a8.1,8.1,0,0,0,5.271-1.741,5.824,5.824,0,0,1,7.712.322,8.367,8.367,0,0,0,10.775.451,5.6,5.6,0,0,1,3.917-1.3,5.863,5.863,0,0,1,1.471.236c.04-.162.077-.325.113-.488a6.463,6.463,0,0,0-1.564-.248",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.328,18.486a6.079,6.079,0,0,0-4.218,1.387,7.876,7.876,0,0,1-10.18-.426,6.313,6.313,0,0,0-8.307-.347,7.559,7.559,0,0,1-5.168,1.656l-.019,0c.062.169.129.334.2.5a8.1,8.1,0,0,0,5.271-1.741,5.824,5.824,0,0,1,7.712.322,8.367,8.367,0,0,0,10.775.451,5.6,5.6,0,0,1,3.917-1.3,5.863,5.863,0,0,1,1.471.236c.04-.162.077-.325.113-.488A6.463,6.463,0,0,0,965.328,18.486Z",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.6,48.534l1.449-1.85a.452.452,0,0,0-.355-.73h-2.9a.452.452,0,0,0-.355.73l1.449,1.85a.45.45,0,0,0,.71,0",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.6,48.534l1.449-1.85a.452.452,0,0,0-.355-.73h-2.9a.452.452,0,0,0-.355.73l1.449,1.85A.45.45,0,0,0,967.6,48.534Z",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.943,
    transform: "translate(-18877.754 -19244.898)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.247,55.694l1.449,1.85a.452.452,0,0,1-.355.73h-2.9a.452.452,0,0,1-.355-.73l1.449-1.85a.45.45,0,0,1,.71,0",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.247,55.694l1.449,1.85a.452.452,0,0,1-.355.73h-2.9a.452.452,0,0,1-.355-.73l1.449-1.85A.45.45,0,0,1,972.247,55.694Z",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y2: 3.943,
    transform: "translate(-18873.107 -19231.465)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.273,51.033a2.6,2.6,0,0,0-2.136,1.094,3.023,3.023,0,0,1-5.115-.214,2.437,2.437,0,0,0-4.174-.174,3.22,3.22,0,0,1-2.616,1.307h-.01c.029.127.061.251.094.376a3.477,3.477,0,0,0,2.669-1.373,2.252,2.252,0,0,1,3.875.162,3.208,3.208,0,0,0,5.414.226,2.408,2.408,0,0,1,1.983-1.025,2.039,2.039,0,0,1,.738.163c.022-.123.042-.246.062-.37a2.205,2.205,0,0,0-.784-.171",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.273,51.033a2.6,2.6,0,0,0-2.136,1.094,3.023,3.023,0,0,1-5.115-.214,2.437,2.437,0,0,0-4.174-.174,3.22,3.22,0,0,1-2.616,1.307h-.01c.029.127.061.251.094.376a3.477,3.477,0,0,0,2.669-1.373,2.252,2.252,0,0,1,3.875.162,3.208,3.208,0,0,0,5.414.226,2.408,2.408,0,0,1,1.983-1.025,2.039,2.039,0,0,1,.738.163c.022-.123.042-.246.062-.37A2.205,2.205,0,0,0,975.273,51.033Z",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.473,48.534l-1.449-1.85a.452.452,0,0,1,.355-.73h2.9a.452.452,0,0,1,.355.73l-1.449,1.85a.45.45,0,0,1-.71,0",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.473,48.534l-1.449-1.85a.452.452,0,0,1,.355-.73h2.9a.452.452,0,0,1,.355.73l-1.449,1.85A.45.45,0,0,1,940.473,48.534Z",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.943,
    transform: "translate(-18904.172 -19244.898)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.827,55.694l-1.449,1.85a.452.452,0,0,0,.355.73h2.9a.452.452,0,0,0,.355-.73l-1.449-1.85a.45.45,0,0,0-.71,0",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.827,55.694l-1.449,1.85a.452.452,0,0,0,.355.73h2.9a.452.452,0,0,0,.355-.73l-1.449-1.85A.45.45,0,0,0,935.827,55.694Z",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y2: 3.943,
    transform: "translate(-18908.818 -19231.465)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.308,51.033a2.6,2.6,0,0,1,2.136,1.094,3.023,3.023,0,0,0,5.115-.214,2.437,2.437,0,0,1,4.174-.174,3.22,3.22,0,0,0,2.616,1.307h.01c-.029.127-.061.251-.094.376a3.477,3.477,0,0,1-2.669-1.373,2.252,2.252,0,0,0-3.875.162,3.208,3.208,0,0,1-5.414.226,2.408,2.408,0,0,0-1.983-1.025,2.039,2.039,0,0,0-.738.163c-.022-.123-.042-.246-.062-.37a2.205,2.205,0,0,1,.784-.171",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.308,51.033a2.6,2.6,0,0,1,2.136,1.094,3.023,3.023,0,0,0,5.115-.214,2.437,2.437,0,0,1,4.174-.174,3.22,3.22,0,0,0,2.616,1.307h.01c-.029.127-.061.251-.094.376a3.477,3.477,0,0,1-2.669-1.373,2.252,2.252,0,0,0-3.875.162,3.208,3.208,0,0,1-5.414.226,2.408,2.408,0,0,0-1.983-1.025,2.039,2.039,0,0,0-.738.163c-.022-.123-.042-.246-.062-.37A2.205,2.205,0,0,1,931.308,51.033Z",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvenSkinTexture);
export default __webpack_public_path__ + "static/media/even-skin-texture.85672f5f.svg";
export { ForwardRef as ReactComponent };